import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-text-large.tsx
/**
* icon.24.text.large
*
* Keywords: typography, letter, serif, font, capital, formatting, character, style
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE5LjUgNGEuNS41IDAgMCAxIC41LjV2M2EuNS41IDAgMCAxLTEgMFY1aC02LjV2MTRIMTVhLjUuNSAwIDAgMSAwIDFIOWEuNS41IDAgMCAxIDAtMWgyLjVWNUg1djIuNWEuNS41IDAgMCAxLTEgMHYtM2EuNS41IDAgMCAxIC41LS41eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-3095
*/
const Icon24TextLarge = memo(function Icon24TextLarge(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M19.5 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V5h-6.5v14H15a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1h2.5V5H5v2.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M4 5.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V6h-6v12h2.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1H11V6H5v2.5a.5.5 0 0 1-1 0z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24TextLarge };

//# sourceMappingURL=icon-24-text-large.js.map